import { render, staticRenderFns } from "./ZheJiang.vue?vue&type=template&id=27bf1a94&scoped=true&"
import script from "./ZheJiang.vue?vue&type=script&lang=js&"
export * from "./ZheJiang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf1a94",
  null
  
)

export default component.exports